import { DATE_FILTERS, getCustomRange, getParsedDateUntilToday } from 'utils/dateUtils'

export const selectData = (state) => state.dashboard.ade.self.data
export const selectLoader = (state) => state.dashboard.ade.self.loader
export const selectError = (state) => state.dashboard.ade.self.error
export const selectDateFilter = (state) => state.dashboard.ade.self.dateFilter

export const selectParsedDate = (state) => {
  const currentDateFilter = selectDateFilter(state)
  return getParsedDateUntilToday(currentDateFilter)
}

export const selectDisplayDate = (state) => {
  const dateFilter = selectDateFilter(state)
  return Array.isArray(dateFilter)
    ? getCustomRange(dateFilter, false, DATE_FILTERS)?.label
    : DATE_FILTERS.find((e) => e.value === dateFilter)?.label
}

export const selectLicenseInfo = (state) => state.dashboard.ade.self.license
export const selectSelectedAddonsToUnlock = (state) =>
  state.dashboard.ade.self.selectedAddonsToUnlock
export const selectLicenseLoader = (state) => state.dashboard.ade.self.licenseLoader
